/* eslint-disable import/prefer-default-export */
import ReactPDF from '@react-pdf/renderer';

export const styles = ReactPDF.StyleSheet.create({
  page: {
    color: '#262626',
    fontFamily: 'Helvetica',
    fontSize: '9px',
    padding: '30px 30px',
  },
  headerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
    alignItems: 'flex-end',
  },
  logo: {
    width: '90px',
    borderRadius: '8px',
  },
  signatureImg: {
    width: '70px',
    height: '70px',
    marginVertical: 20,
  },
  invoiceTitle: {
    color: '#4B6FAD',
    textAlign: 'right',
    fontSize: 20,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  headerRightInfo: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 16,
    gap: 24,
  },
  maxWidth: {
    maxWidth: 100,
  },
  information: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 32,
  },

  maxWidthQuantity: {
    maxWidth: 55,
  },
  textCenter: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  textRightFlex: {
    textAlign: 'right',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  darkBlueColor: {
    color: '#33427F',
  },
  darkGreyColor: {
    color: '#727D8A',
  },
  marginBottom: {
    marginBottom: 8,
  },
  widthHalf: {
    flexGrow: 1,
    width: '50%',
  },
  line: {
    borderTop: '1px solid black',
    marginVertical: 8,
  },
  lineMarginBottom: {
    borderBottom: '1px solid #727D8A',
    marginBottom: 8,
  },
  paddingBottom: {
    paddingBottom: 16,
  },
  textRight: {
    textAlign: 'right',
  },
  textBold: {
    fontFamily: 'Helvetica-Bold',
  },
  spaceY: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  alignEnd: {
    alignItems: 'flex-end',
  },
  alignStart: {
    alignItems: 'flex-start',
  },
  totals: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  amountDue: {
    fontSize: 10,
  },
  signature: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: 20,
  },
  desc: {
    lineHeight: 0.4,
  },
});

// Definisi lebar kolom (total 100%)
export const columnWidths = {
  product: '15%', // Produk - ukuran sedang
  description: '35%', // Deskripsi - ukuran terbesar
  quantity: '8%', // Kuantitas - ukuran kecil
  price: '12%', // Harga - ukuran sedang
  discount: '10%', // Diskon - ukuran sedang
  tax: '8%', // Pajak - ukuran kecil
  amount: '12%', // Jumlah - ukuran sedang
};

// Definisi styling tambahan untuk mengatasi masalah tabel
export const tableStyles = ReactPDF.StyleSheet.create({
  table: {
    width: '100%',
    borderColor: '1px solid #fff',
    margin: '20px 0',
  },
  thead: {
    borderColor: '1px solid #fff',
    backgroundColor: '#2E3E4E',
    fontFamily: 'Helvetica-Bold',
    color: '#fff',
  },
  td: {
    borderColor: '1px solid #fff',
    padding: 6,
  },
  // Gaya untuk sel produk
  productCell: {
    width: columnWidths.product,
    padding: 5,
  },
  // Gaya untuk sel deskripsi dengan batasan tinggi dan overflow handling
  descriptionCell: {
    width: columnWidths.description,
    padding: 5,
    fontSize: 9, // Ukuran font lebih kecil untuk konten deskripsi
  },
  // Gaya untuk sel kuantitas
  quantityCell: {
    width: columnWidths.quantity,
    padding: 5,
    textAlign: 'center',
  },
  // Gaya untuk sel harga
  priceCell: {
    width: columnWidths.price,
    padding: 5,
    textAlign: 'right',
  },
  // Gaya untuk sel diskon
  discountCell: {
    width: columnWidths.discount,
    padding: 5,
    textAlign: 'right',
  },
  // Gaya untuk sel pajak
  taxCell: {
    width: columnWidths.tax,
    padding: 5,
    textAlign: 'right',
  },
  // Gaya untuk sel jumlah
  amountCell: {
    width: columnWidths.amount,
    padding: 5,
    textAlign: 'right',
  },
  // Fix untuk row tinggi tetap
  fixedRow: {
    border: '1px solid #fff',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'nowrap',
    backgroundColor: '#f1f1f1',
  },
  // Gaya untuk header kolom
  headerCell: {
    backgroundColor: '#2E3E4E',
    color: 'white',
    padding: 5,
    fontWeight: 'bold',
    fontSize: 10,
  },
  // Gaya untuk table utama
  mainTable: {
    width: '100%',
    marginBottom: 16,
    marginTop: 8,
    borderCollapse: 'collapse',
  },
});
